export const environment = {
  endpoint: 'https://admin-stg.concursoplus.com/',
  production: true,
  storage: 'bat-concurso',
  title: 'Concurso',
};
